import { formControlForColumn } from '../../../shared/column-kind.js'
import { durationUnit } from '../../../shared/duration-column.js'

const ADD_ALL_COLUMN_VIEW_TYPES = ['form', 'login', 'registration', 'table', 'cards', 'card', 'maps', 'calendar']

export function viewSupportsAddAllColumns (componentType) {
  return ADD_ALL_COLUMN_VIEW_TYPES.includes(componentType)
}

function formFieldFromColumn (column) {
  const type = formControlForColumn(column)

  if (!type) return null

  const field = {
    type,
    uniqueTitle: column.uniqueTitle,
    columnType: column.type,
    title: '',
    description: '',
    placeholder: ''
  }

  if (column.type === 'image') field.allowImageUrl = true
  if (column.type === 'duration') field.durationUnit = durationUnit(column)

  if (column.type === 'multiselect') {
    field.choices = Array.isArray(column.choices) ? column.choices.slice() : []
    field.displayStyle = 'dropdown'
    field.selectionMode = column.selectionMode === 'single' ? 'single' : 'multiple'
  }

  return field
}

function dataFieldFromColumn (column) {
  let dataType = 'dataColumn'

  if (column.type === 'image' || column.type === 'signature') dataType = 'dataImage'
  else if (column.type === 'file') dataType = 'dataFile'
  else if (column.type === 'richText') dataType = 'dataRichText'

  return {
    type: dataType,
    uniqueTitle: column.uniqueTitle,
    label: column.title || column.uniqueTitle,
    childPageUniqueTitle: undefined,
    customText: undefined
  }
}

export function buildComponentsFromSpreadsheetColumns (columns, componentType) {
  const sourceColumns = Array.isArray(columns) ? columns : []

  if (componentType === 'form' || componentType === 'login' || componentType === 'registration') {
    const fieldComponents = sourceColumns
      .filter((column) => column.type !== 'relationship' && column.type !== 'sequence')
      .map(formFieldFromColumn)
      .filter(Boolean)

    if (!fieldComponents.length) return []

    return [{
      type: 'formRow',
      components: [{
        type: 'formGroup',
        components: fieldComponents
      }]
    }]
  }

  if (componentType === 'table' || componentType === 'cards' || componentType === 'card' || componentType === 'calendar') {
    return sourceColumns.map(dataFieldFromColumn)
  }

  return []
}
